module.exports = __webpack_public_path__ + "static/sanofi-logo-673e8d09f97cb270f4319aa3a0e997dd.jpg";